// extracted by mini-css-extract-plugin
module.exports = {"box":"box--3F2jz","content":"content--huOEz","iconBg":"iconBg--2yrcf","errTxt":"errTxt--wxr6t","description":"description--21SBI"};